<template>
    <j-page class="collect-config-layout">
        <div slot="search">
            <el-button type="info" icon="el-icon-paperclip"  :disabled="tableSelection.length < 1" @click="addDgmxInsertEvent">插入</el-button>
            <el-button type="info" icon="el-icon-setting" :disabled="!(tableSelection[0] && (tableSelection[0].fieldOrigin == 0 || tableSelection[0].fieldOrigin == 2))" @click="editDgmxEvent">设置</el-button>
            <el-button type="info" icon="el-icon-delete"  :disabled="!(tableSelection[0] && (tableSelection[0].fieldOrigin == 0 || tableSelection[0].fieldOrigin == 3))" @click="delEvent">删除</el-button>
            <el-button type="info" icon="el-icon-sort-up" :disabled="tableSelection.length < 1 || (tableSelection[0] && tableSelection[0].index === 0)" @click="sortableEvent(`/api/fieldModels/${meta.ledgerId}/orderInputUp`)">上移</el-button>
            <el-button type="info" icon="el-icon-sort-down" :disabled="tableSelection.length < 1 || (tableSelection[0] && tableSelection[0].index === tableData[tableData.length - 1].index)" @click="sortableEvent(`/api/fieldModels/${meta.ledgerId}/orderInputDown`)">下移</el-button>
        </div>
        <div slot="table" class="collect-config-layout-content">
            <div class="table-wrap">
                <el-table ref="collectDom" :row-class-name="tableRowClassName" v-loading="tableLoading" :data="tableData" @select="checkBoxEvent" @current-change="selectEvent" height="100%" stripe>
                    <el-table-column type="selection"  width="50" />
                    <el-table-column prop="fieldNeedInput" label="" width="40">
                        <span v-if="row.fieldOrigin == 2" slot-scope="{ row }">
                            <i v-if="row.fieldNeedInput" class="el-icon-success" style="color: #67C23A;" title="已采集" />
                            <i v-else class="el-icon-error" style="color: #F56C6C;" title="未采集" />
                        </span>
                        <i v-else class="el-icon-remove" style="color: #409EFF;" title="显示元素" />
                    </el-table-column>
                    <el-table-column prop="fieldName" label="名称"  show-overflow-tooltip />
<!--                    <el-table-column prop="fieldOrigin" label="类别"  show-overflow-tooltip>-->
<!--                        <j-dictionary slot-scope="{ row }" code="CONDIG_FIELD_ORIGIN" :value="row.fieldOrigin" />-->
<!--                    </el-table-column>-->
<!--                    <el-table-column prop="fieldNeedInput" label="需要采集"  show-overflow-tooltip>-->
<!--                        <j-dictionary slot-scope="{ row }" code="YES_OR_NO" :value="row.fieldNeedInput" />-->
<!--                    </el-table-column>-->
<!--                    <el-table-column prop="autoGenerate" label="自动生成"  show-overflow-tooltip>-->
<!--                        <j-dictionary slot-scope="{ row }" code="YES_OR_NO" :value="row.autoGenerate" />-->
<!--                    </el-table-column>-->
                    <el-table-column prop="fieldInputType" label="录入方式"  show-overflow-tooltip>
                        <j-dictionary v-if="row.fieldInputType" slot-scope="{ row }" code="FIELD_INPUT_TYPE" :value="row.fieldInputType" />
                        <span v-else>-</span>
                    </el-table-column>
                    <el-table-column prop="fieldDicKeyInputFormat" label="格式"  show-overflow-tooltip >
                        <template slot-scope="{ row }">
                            <j-dictionary v-if="row.fieldInputType == 1" :code="`FIELD_INPUT1_FORMAT`" :value="row.fieldDicKeyInputFormat" />
                            <j-dictionary v-else-if="[6,7,8,9].includes(row.fieldInputType)" :code="`FIELD_INPUT2_FORMAT`" :value="row.fieldDicKeyInputFormat" />
<!--                            <span v-else>{{row.fieldDicKeyInputFormat}}</span>-->
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="fieldDicKey" label="字典项"  show-overflow-tooltip>
                        <span slot-scope="{ row }">{{row.fieldDicKey || '-'}}</span>
                    </el-table-column>
<!--                    <el-table-column prop="fieldRequired" label="必填"  show-overflow-tooltip>-->
<!--                        <j-dictionary type="select" slot-scope="{ row }" code="YES_OR_NO" :value="row.fieldRequired" />-->
<!--                    </el-table-column>-->
<!--                    <el-table-column prop="fieldUniqued" label="唯一"  show-overflow-tooltip>-->
<!--                        <j-dictionary type="select" slot-scope="{ row }" code="YES_OR_NO" :value="row.fieldUniqued" />-->
<!--                    </el-table-column>-->
                </el-table>
            </div>
            <div class="preview-wrap-box">
<!--                <div class="preview-wrap-title">采集配置预览</div>-->
                <div class="preview-wrap" v-loading="tableLoading">
                    <rule-form v-if="showRule" :meta="tableData" :forms="forms" :rules="rules" :loadDic="loadDic" />
                </div>
            </div>
        </div>

        <!--        插入-->
        <el-dialog v-if="showDgmxInsert" :title="dgmxTypeMapInsert[dgmxType]" :visible.sync="showDgmxInsert" width="400px" append-to-body :close-on-click-modal="false">
            <el-form ref="dgmxDom" :model="dgmxFormInsert" :rules="dgmxRuleInsert" label-width="60px" @keydown.native.enter="checkDgmxEvent('saveDgmxDataInsert')">
                <el-form-item v-if="dgmxType === 'ADD'" label="类别" prop="fieldOrigin">
                    <el-radio-group v-model="dgmxFormInsert.fieldOrigin">
                        <el-radio :label="0">分组</el-radio>
                        <el-radio :label="3">占位符</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="dgmxFormInsert.fieldOrigin == 0" label="名称" prop="fieldName">
                    <el-input v-model.trim="dgmxFormInsert.fieldName" placeholder="请输入字段名称" maxlength="100" show-word-limit clearable />
                </el-form-item>
            </el-form>
            <template slot="footer">
                <el-button type="primary" @click="checkDgmxEvent('saveDgmxDataInsert')" :loading="submitLoad">保存</el-button>
                <el-button type="info" @click="showDgmxInsert = false">取消</el-button>
            </template>
        </el-dialog>

        <!--        字段设置-->
        <el-dialog v-if="showDgmx" :title="dgmxTypeMap[dgmxType]" :visible.sync="showDgmx" width="400px" append-to-body :close-on-click-modal="false">
            <el-form ref="dgmxDom" :model="dgmxForm" :rules="dgmxRule" :label-width="dgmxFormLabelWidth" @keydown.native.enter="checkDgmxEvent('saveDgmxData')">
                <el-form-item label="字段名称" prop="fieldName">
                    <el-input v-model.trim="dgmxForm.fieldName" placeholder="字段名称" readonly />
                </el-form-item>
                <el-form-item label="需要采集" prop="fieldNeedInput">
                    <el-radio-group v-model="dgmxForm.fieldNeedInput">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="录入方式" prop="fieldInputType">
                    <j-dictionary type="select" v-model="dgmxForm.fieldInputType" code="FIELD_INPUT_TYPE" placeholder="请选择录入方式" @change="fieldInputTypeChange" />
                </el-form-item>
                <!--                输入框-->
                <el-form-item v-if="dgmxForm.fieldInputType == 1" label="格式" prop="fieldDicKeyInputFormat">
                    <j-dictionary type="select" v-model="dgmxForm.fieldDicKeyInputFormat" :code="`FIELD_INPUT1_FORMAT`" placeholder="请选择格式" />
                </el-form-item>
                <!--                下拉框/选择框-->
                <template v-if="[6,7,8,9].includes(Number(dgmxForm.fieldInputType))">
                    <el-form-item label="格式" prop="fieldDicKeyInputFormat">
                        <j-dictionary type="select" v-model="dgmxForm.fieldDicKeyInputFormat" :code="`FIELD_INPUT2_FORMAT`" placeholder="请选择格式" />
                    </el-form-item>
                    <!--                格式为系统字典-->
                    <el-form-item v-if="dgmxForm.fieldDicKeyInputFormat == 1" label="字典项" prop="fieldDicKey">
                        <el-select style="width: 100%;" v-model="dgmxForm.fieldDicKey" filterable placeholder="请选择字典项">
                            <el-option v-for="(item, i) in systemDictionary" :key="i" :label="item.value" :value="item.key" />
                        </el-select>
                    </el-form-item>
                </template>
                <el-form-item label="必填" prop="fieldRequired">
                    <el-radio-group v-model="dgmxForm.fieldRequired">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </el-form-item>
<!--                <el-form-item label="唯一" prop="fieldUniqued">-->
<!--                    <el-radio-group v-model="dgmxForm.fieldUniqued">-->
<!--                        <el-radio :label="true">是</el-radio>-->
<!--                        <el-radio :label="false">否</el-radio>-->
<!--                    </el-radio-group>-->
<!--                </el-form-item>-->
            </el-form>
            <template slot="footer">
                <el-button type="primary" @click="checkDgmxEvent('saveDgmxData')" :loading="submitLoad">保存</el-button>
                <el-button type="info" @click="showDgmx = false">取消</el-button>
            </template>
        </el-dialog>
    </j-page>
</template>

<script>
    import PageMixins from "../../../../components/JComponents/JPage/mixins/PageMixins";
    import DialogMixins from "../../../../components/JComponents/JPage/mixins/DialogMixins";
    import ruleMixins from "../../../../components/DynamicForms/RuleForm/ruleMixins";
    export default {
        name: "collectConfig",
        mixins: [PageMixins, DialogMixins, ruleMixins],
        props: ['meta'],
        data () {
            return {
                systemDictionary: [],
                showRule: false,
                showDgmxInsert: false,
                dgmxTypeMap: {
                    'EDIT': '字段设置',
                },
                dgmxForm: {
                    "fieldDicKey": "",
                    "fieldDicKeyInputFormat": '',
                    "fieldInputType": '',
                    "fieldModelId": '',
                    "fieldName": "",
                    "fieldNeedInput": '',
                    "fieldRequired": '',
                    "fieldUniqued": ''
                },
                dgmxRule: {
                    fieldDicKey: [{ required: true, message: '请选择字典项', trigger: 'change' }],
                    fieldDicKeyInputFormat: [{ required: true, message: '请选择格式', trigger: 'change' }],
                    fieldInputType: [{ required: true, message: '请选择录入方式', trigger: 'change' }],
                    fieldNeedInput: [{ required: true, message: '请选择是否需要采集', trigger: 'change' }],
                    fieldRequired: [{ required: true, message: '请选择是否必填', trigger: 'change' }],
                    fieldUniqued: [{ required: true, message: '请选择是否唯一', trigger: 'change' }],
                },
                dgmxTypeMapInsert: {
                    'ADD': '插入',
                    'EDIT': '设置分组'
                },
                dgmxFormInsert: {
                    fieldName: '',
                    fieldOrigin: ''
                },
                dgmxRuleInsert: {
                    fieldName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                    fieldOrigin: [{ required: true, message: '请选择类别', trigger: 'change' }]
                }
            }
        },
        created () {
            this.getSystemDictionary()
            this.load()
        },
        methods: {
            // 把每一行的索引放进row
            tableRowClassName({ row, rowIndex }) {
                row.index = rowIndex
            },
            checkBoxEvent (all, row) {
                if (all.length > 0) {
                    // console.log('切换了', '当前的是', all.pop().fieldName)
                    this.$refs.collectDom.clearSelection()
                    this.$refs.collectDom.toggleRowSelection(row)
                    this.tableSelection = [row]
                } else {
                    // console.log('取消勾选')
                    this.$refs.collectDom.clearSelection()
                    this.tableSelection = []
                }
            },
            selectEvent (row) {
                this.$refs.collectDom.clearSelection()
                this.$refs.collectDom.toggleRowSelection(row)
                this.tableSelection = [row]
            },
            async getGridDictionary () {
                const { data } = await this.$http.get(`/api/dictionaries/support-list`)
                return data.data.map(item => ({ key: `grid_support:dic_prefix:${item.dictionaryKey}`, value: `${item.name}(字典服务)` })) || []
            },
            async getLocalDictionary () {
                const { data } = await this.$http.get(`/api/dictionaries/local-list`)
                return data.data.map(item => ({ key: `base:local:dic:${item.key}`, value: `${item.value}(本地字典)` })) || []
            },
            async getSystemDictionary () {
                const localDictionary = await this.getLocalDictionary()
                const gridDictionary = await this.getGridDictionary()
                this.systemDictionary = [...localDictionary, ...gridDictionary]
            },
            fieldInputTypeChange () {
                this.dgmxForm.fieldDicKeyInputFormat = ''
                this.dgmxForm.fieldDicKey = ''
            },
            async load () {
                this.showRule = false
                this.tableSelection = []
                this.tableLoading = true
                const { data } = await this.$http.get(`/api/fieldModels/${this.meta.ledgerId}/listFieldsOfInput`)
                this.tableData = data.data
                this.renderHandle(data.data, this.forms, this.rules, this.loadDic)
                this.showRule = true
                this.tableLoading = false
            },
            editDgmxEvent () {
                this.dgmxType = 'EDIT'
                this.curItem = { ...this.tableSelection[0] }
                if (this.curItem.fieldOrigin == 2) {
                    this.dgmxForm = { ...this.dgmxForm, ...this.curItem }
                    this.showDgmx = true
                } else if (this.curItem.fieldOrigin == 0) {
                    this.dgmxFormInsert = { ...this.dgmxFormInsert, ...this.curItem }
                    this.showDgmxInsert = true
                }
            },
            async saveDgmxData () {
                if (this.submitLoad) return
                this.submitLoad = true
                let method = 'put'
                let url = `/api/fieldModels/${this.meta.ledgerId}/setInputCustom`
                const { data } = await this.$http[method](url, this.dgmxForm)
                    .catch(({response}) => { this.$message.error(response.data.msg) })
                    .finally(() => { this.submitLoad = false })
                if (data.status !== 'yes') return this.$message.error(data.msg)
                this.showDgmx = false
                this.$message.success('提交成功')
                this.load()
            },
            addDgmxInsertEvent () {
                this.dgmxType = 'ADD'
                this.showDgmxInsert = true
            },
            async saveDgmxDataInsert () {
                if (this.submitLoad) return
                this.submitLoad = true
                let method = 'post'
                let url = `/api/fieldModels/${this.meta.ledgerId}/addCustomField`
                if (this.dgmxType === 'EDIT') {
                    url = `/api/fieldModels/${this.meta.ledgerId}/addCustomField`
                    method = 'put'
                }
                if (this.dgmxFormInsert.fieldOrigin == 3) this.dgmxFormInsert.fieldName = '占位符'
                const { data } = await this.$http[method](url, { ...this.dgmxFormInsert, aftFieldModelId: this.tableSelection[0].fieldModelId })
                    .catch(({response}) => { this.$message.error(response.data.msg) })
                    .finally(() => { this.submitLoad = false })
                if (data.status !== 'yes') return this.$message.error(data.msg)
                this.showDgmxInsert = false
                this.$message.success('提交成功')
                this.load()
            },
            async sortableEvent (url) {
                const fieldModelId = this.tableSelection[0].fieldModelId
                await this.$http.post(`${url}/${fieldModelId}`)
                this.$message.success('移动成功')
                this.load()
            },
            delEvent () {
                this.$confirm('您确认要删除当前项吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http
                        .request({
                            method: 'delete',
                            url: `/api/fieldModels/${this.meta.ledgerId}/delCustomField/${this.tableSelection[0].fieldModelId}`
                        })
                        .then((res) => {
                            if (res.data.status !== 'yes') return this.$message.error(res.data.msg)
                            this.$message.success('删除成功')
                            this.load && this.load()
                        })
                })
            },
            checkDgmxEvent (funName) {
                this.$refs['dgmxDom'].validate((valid) => {
                    if (valid) {
                        this[funName]()
                    }
                })
            }
        },
        watch: {
            showDgmxInsert (nv) {
                if (!nv) {
                    this.dgmxFormInsert = { ...this.$options.data().dgmxFormInsert }
                }
            }
        }
    }
</script>

<style lang="scss">
    .collect-config-layout {
        /* 禁用全选 */
        .el-table__header-wrapper .el-checkbox__input{
            display: none;
        }
    }
    .collect-config-layout-content {
        display: flex;
        .table-wrap {
            flex: 1;
            min-width: 100px;
        }
        .preview-wrap-box {
            display: flex;
            flex-direction: column;
            margin-left: 10px;
        }
        .preview-wrap-title {
            font-size: 14px;
        }
        .preview-wrap {
            flex: 1;
            min-height: 100px;
            width: 400px;
            padding: 16px;
            box-sizing: border-box;
            border: 1px dashed #DFE1E6;
            border-radius: 8px;
            /*background-color: rgba(255,255,255,.1);*/
            overflow-x: hidden;
            overflow-y: auto;
            .el-form-item__label {
                width: auto;
                max-width: 120px;
            }
            .rule-form-wrap {
                .rule-form {
                    &:empty { height: 530px!important; }
                }
            }
        }
    }
</style>
